<template>
  <div
    class="hero"
    :class="`hero--${props.brandExperience}`"
    :style="[
      dataModel[props.brandExperience].hero.video.active
        ? { background: dataModel[props.brandExperience].hero.video.bgColor }
        : { background: dataModel[props.brandExperience].hero.bgImg.bgColor },
    ]"
  >
    <div
      class="hero__width"
      :style="[
        dataModel[props.brandExperience].hero.video.active
          ? {
              maxWidth: '1280px',
              background: dataModel[props.brandExperience].hero.video.bgColor,
            }
          : {
              maxWidth: dataModel[props.brandExperience].hero.bgImg.maxWidth,
              background: `url(./hero/hero-${props.brandExperience}/background.jpg)`,
            },
      ]"
    >
      <!-----------------------
      -- BACKGROUND VIDEO START
      ------------------------>
      <video
        v-if="dataModel[props.brandExperience].hero.video.active"
        id="hero-video"
        width="100%"
        playsinline
        autoplay="true"
        muted
        loop
        poster=""
        controls="false"
        preload="auto"
      >
        <source
          id="hero-video-source"
          :src="`./hero/hero-${props.brandExperience}/video.mp4`"
          type="video/mp4"
        />
        Your browser does not support HTML video.
      </video>
      <!-----------------------
      -- BACKGROUND END START
      ------------------------>
      <!-----------------------
      -- BACKGROUND IMG START
      ------------------------>
      <div v-else class="hero__background"></div>
      <!-----------------------
      -- BACKGROUND IMG END
      ------------------------>

      <slot></slot>
      <div
        :style="[
          dataModel[props.brandExperience].hero.video.active
            ? {
                background:
                  dataModel[props.brandExperience].hero.video.gradLeft,
              }
            : {
                background:
                  dataModel[props.brandExperience].hero.bgImg.gradLeft,
              },
        ]"
        class="grad--left"
      ></div>
      <div
        :style="[
          dataModel[props.brandExperience].hero.video.active
            ? {
                background:
                  dataModel[props.brandExperience].hero.video.gradRight,
              }
            : {
                background:
                  dataModel[props.brandExperience].hero.bgImg.gradRight,
              },
        ]"
        class="grad--right"
      ></div>
    </div>
    <div
      class="hero__surface"
      v-bind:style="{
        background: `url(./hero/hero-${props.brandExperience}/surface.png)`,
      }"
    ></div>
    <!-----------------------
      -- SERVES START
      ------------------------>
    <img
      :src="`hero/hero-${props.brandExperience}/product.png`"
      class="hero__product"
    />
    <img
      v-if="dataModel[props.brandExperience].hero.serve_1"
      :src="`./hero/hero-${props.brandExperience}/serve-1.png`"
      class="hero__serve hero__serve--1"
    />
    <img
      v-if="dataModel[props.brandExperience].hero.serve_2"
      :src="`./hero/hero-${props.brandExperience}/serve-2.png`"
      class="hero__serve hero__serve--2"
    />
    <!-----------------------
    -- SERVES END
    ------------------------>
  </div>
</template>

<script setup>
import dataModel from "../js/model.js";
import tagAnimation from "../js/context/animation.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
});
$(document).ready(function() {
  tagAnimation();
});

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.hero {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  overflow: hidden;
  position: relative;
  width: 100%;
}
.hero__tag {
  background-color: #1c449c; 
  color: #ffffff;
  font-size: 30px; 
  font-weight: bold; 
  height: 60px;
  position: absolute; 
  left: 50px; 
  top:0px; 
  width: 140px;
  z-index: 105;

  @media (max-width: 600px) {
    bottom: 30px;
    background-color: #1c449c; 
    color: #ffffff;
    font-size: 30px; 
    font-weight: bold; 
    height: 60px;
    position: absolute; 
    left: 0px; 
    top:auto; 
    width: 140px;
    z-index: 105;
  }
}
.hero__width {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  height: 560px;
  max-width: 1280px;
  overflow: hidden;
  position: relative;
  width: 100%;
  @media (max-width: $width--s) {
    height: 520px;
  }
  & .grad--left {
    content: "";
    height: 100%;
    left: 0px;
    position: absolute;
    width: 200px;
    z-index: 100;
    @media (max-width: $width--xs) {
      opacity: 0;
    }
  }
  & .grad--right {
    content: "";
    height: 100%;
    right: 0px;
    position: absolute;
    width: 200px;
    z-index: 100;
    @media (max-width: $width--xs) {
      opacity: 0;
    }
  }
}
#hero-video {
  height: 660px;
  position: absolute;
  top: 0;
  width: auto;

  @media (max-width: $width--s) {
    height: 100%;
  }
}
.hero__background {
  background-size: cover;
  height: 660px;
  position: absolute;
  width: 100%;
}
.hero__surface {
  background-size: cover;
  bottom: 0px;
  height: 50%;
  position: absolute;
  width: 100%;
  z-index: 101;
  @media (max-width: $width--s) {
    height: 40%;
  }
}
.hero__product {
  bottom: 0px;
  height: auto;
  left: 70%;
  position: absolute;
  width: 200px;
  z-index: 150;
  @media (max-width: $width--xs) {
    left: auto;
    right: 20px;
    width: 120px;
  }
}
.hero__serve {
  height: auto;
  position: absolute;
  width: 450px;
  z-index: 102;
  &--1 {
    left: 3%;
    bottom: 20px;
    z-index: 103;
    @media (max-width: 1600px) {
      left: -8%;
    }
    @media (max-width: 1300px) {
      left: -20%;
    }
    @media (max-width: $width--m) {
      bottom: -20px;
      left: -250px;
    }
    @media (max-width: $width--s) {
      bottom: -60px;
      left: -100px;
      width: 350px;
    }
    @media (max-width: $width--xxs) {
      bottom: -80px;
      left: -160px;
      width: 400px;
    }
  }
  &--2 {
    left: 13%;
    bottom: 80px;
    z-index: 102;
    @media (max-width: 1600px) {
      left: 3%;
    }
    @media (max-width: 1300px) {
      left: -5%;
    }
    @media (max-width: $width--m) {
      left: -140px;
    }
    @media (max-width: $width--s) {
      display: none;
    }
  }
}
.hero--2 {
  & .hero__width {
    @media (max-width: $width--s) {
      height: 550px;
    }
  }
  & .hero__serve {
    bottom: -150px;
    left: 0%;
    width: 650px;
    @media (max-width: $width--s) {
      bottom: -100px;
      left: -100px;
      width: 400px;
    }
  }
}
.hero--9 {
  & .hero__surface {
    background-size: auto 100% !important;
    height: 40%;
  }
  & .hero__product {
    @media (max-width: $width--m) {
      left: auto;
      right: 50px;
      width: 160px;
    }
    
    @media (max-width: $width--s) {
      left: auto;
      right: 50px;
      width: 140px;
    }
    @media (max-width: $width--xs) {
      left: auto;
      right: 20px;
      width: 140px;
    }
    @media (max-width: $width--xxs) {
      left: auto;
      right: 20px;
      width: 130px;
    }
    @media (max-width: $width--xxxs) {
      left: auto;
      right: 20px;
      width: 120px;
    }
  }
  & .hero__serve {
    height: auto;
    position: absolute;
    width: 450px;
    z-index: 102;
    &--1 {
      left: 0%;
      bottom: 0px;
      z-index: 103;
      @media (max-width: 1600px) {
        left: -12%;
      }
      @media (max-width: 1300px) {
        left: -20%;
      }
    
      @media (max-width: $width--m) {
        bottom: -20px;
        left: -220px;
        width: 400px;
      }
      @media (max-width: $width--s) {
        bottom: -160px;
        left: -200px;
        width: 450px;
      }
      @media (max-width: $width--xs) {
        bottom: 20px;
        display: block;
        left: -120px;
        width: 270px;
      }
   
    }
    &--2 {
      left: 10%;
      bottom: -100px;
      width: 400px;
      z-index: 103;
      @media (max-width: 1600px) {
        left: 0%;
      }
      @media (max-width: 1300px) {
        left: -5%;
      }
      @media (max-width: $width--m) {
        display: none;
      }
 
      @media (max-width: $width--xs) {
        bottom: -50px;
        display: block;
        left: -20px;
        width: 250px;
      }
      @media (max-width: $width--xxs) {
        left: -50px;
        bottom: -50px;
        display: block;
      }
      @media (max-width: $width--xxxs) {
        width: 240px;
        left: -80px;
        bottom: -120px;
        display: none;
      }
    }
  }
}
</style>